import styles from "./averages-component.module.css";

import AverageItem from "./AverageItem";
import { useTranslation } from "react-i18next";
import { ClientDashboardStore, StoryStatusTypes } from "../../../store/store";
import { inject, observer } from "mobx-react";

interface AveragesComponentProps {
    clientDashboardStore?: ClientDashboardStore;
}

function AveragesComponent(props: AveragesComponentProps) {
    const { t } = useTranslation("dashboard");

    const clientDashboardStore = props.clientDashboardStore!;
    const { historicalTab } = clientDashboardStore;
    const periodStatistics = clientDashboardStore.periodStatistics;

    const getValue = (index: string) => {
        if (historicalTab === 0) {
            return (periodStatistics.sevenDays.hours as any)[index] / 7;
        }

        return (periodStatistics.thirtyDays.hours as any)[index] / 30;
    };

    const items = [
        {
            color: "#868483",
            label: t("AverageOutOfRoom"),
            value: getValue("OutOfRoom"),
        },
        {
            color: "#2476B9",
            label: t("AverageInBathroom"),
            value: getValue("InBathroom"),
        },
        {
            color: "#52D9E3",
            label: t("AverageInRoom"),
            value: getValue("InRoom"),
        },
        {
            color: "#064F58",
            label: t("AverageInBed"),
            value: getValue("InBed"),
        },
        {
            color: "#7EBBBE",
            label: t("AverageOutOfBed"),
            value: getValue("OutOfBed"),
        },
        {
            color: "#87A5B4",
            label: t("AverageOther"),
            value: getValue("Other"),
        },
    ];

    if (getValue("OutOfBed") === 0) {
        const indexOutOfBed = items.findIndex((value) => {
            return value.label === t("AverageOutOfBed");
        });

        if (indexOutOfBed > 0) {
            items.splice(indexOutOfBed, 1);
        }
    }

    if (getValue("Other") === 0) {
        const indexOther = items.findIndex((value) => {
            return value.label === t("AverageOther");
        });

        if (indexOther > 0) {
            items.splice(indexOther, 1);
        }
    }

    const render = () => (
        <div className={styles["average-component"]}>
            {items.map((item) => {
                return (
                    <AverageItem
                        color={item.color}
                        label={item.label}
                        value={item.value}
                    />
                );
            })}
        </div>
    );

    return render();
}

export default inject("clientDashboardStore")(observer(AveragesComponent));
